import { ThemeTagType } from "entities/themeTagTypes/types";
import { QueryDocumentSnapshot, Timestamp } from "firebase/firestore";
import { DocumentData, DocumentSnapshot } from "shared/api/firebase";

type ThemeTagTypeDBT = {
  id: string;
  name: string;
  createdAt: Timestamp;
};

type ThemeTagTypeDataT = Omit<ThemeTagTypeDBT, "id">;

export class ThemeTagTypeDB {
  id: string;

  name: string;

  createdAt: Timestamp;

  constructor(tag: QueryDocumentSnapshot | DocumentSnapshot<DocumentData>) {
    if (!tag.exists()) {
      throw new Error(`Theme Tag ${tag.id} does not exist`);
    }

    const data = tag.data() as ThemeTagTypeDataT;

    this.id = tag.id;
    this.name = data.name;
    this.createdAt = data.createdAt;
  }

  toThemeTagType(): ThemeTagType {
    return {
      id: this.id,
      name: this.name,
      createdAt: this.createdAt
        ? this.createdAt?.toDate().toISOString()
        : new Date().toISOString(),
    };
  }
}
